/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import { IntlService as t } from "../Intl/IntlService.mjs";
import { LocalizationService as e } from "../Localization/LocalizationService.mjs";
const r = o.createContext({
  intl: new t("en"),
  localization: new e()
});
export {
  r as GlobalizationContext
};
